import { firebase } from 'util/auth'
const BASE_URL = process.env.REACT_APP_APP_BASE_URL;

export const refundPaymentIntent = async (paymentIntentId, partnerId) => {

    let requestOptions = null
    const headers = await buildHeaders()
    if (headers) {
        requestOptions = {
            method: 'POST',
            headers: headers
        }
    } else {
        throw Error("Not authenticated??")
    }

    const response = await fetch(`${BASE_URL}/app/refundPayment?paymentIntentId=${paymentIntentId}&partnerId=${partnerId}`, requestOptions)

    console.log("got a response")
    return response.json()
}

export const refundUserReservation = async (reservationId) => {

    let requestOptions = null
    const headers = await buildHeaders()
    if (headers) {
        requestOptions = {
            method: 'POST',
            headers: headers
        }
    } else {
        throw Error("Not authenticated??")
    }

    const response = await fetch(`${BASE_URL}/app/refundReservation?reservationId=${reservationId}`, requestOptions)

    console.log("got a response")
    return response.json()
}

export const cancelReservation = async (reservationId) => {

    let requestOptions = null
    const headers = await buildHeaders()
    if (headers) {
        requestOptions = {
            method: 'POST',
            headers: headers
        }
    } else {
        throw Error("Not authenticated??")
    }



    const response = await fetch(`${BASE_URL}/app/cancelReservation?reservationId=${reservationId}`, requestOptions)

    if (!response.ok) {
        throw response.json()
        return
    }
    return response.json()
}

export const wakeupCheckout = async () => {
    const response = await fetch(`${BASE_URL}/app`,)

    return response
}

export const getClassCheckout = async (classId, couponCode = null, widgetName = null) => {

    let request = null
    const headers = await buildHeaders()
    if (headers) {
        request = {
            headers: headers
        }
    }

    if (couponCode) {
        couponCode = encodeURIComponent(couponCode)
    }

    const response = await fetch(`${BASE_URL}/app/checkout?classId=${classId}&couponCode=${couponCode ?? ""}&widgetName=${widgetName}`, request)

    return response.json()
}

export const getOfferingCheckout = async (offeringId, couponCode = null) => {

    let request = null
    const headers = await buildHeaders()
    if (headers) {
        request = {
            headers: headers
        }
    }

    if (couponCode) {
        couponCode = encodeURIComponent(couponCode)
    }

    const response = await fetch(`${BASE_URL}/app/checkout?offeringId=${offeringId}&couponCode=${couponCode ?? ""}`, request)

    return response.json()
}

export const getGiftcardCheckout = async (partnerId) => {

    let request = null
    const headers = await buildHeaders()
    if (headers) {
        request = {
            headers: headers
        }
    }

    const response = await fetch(`${BASE_URL}/app/checkout?giftPartnerId=${partnerId}`, request)

    return response.json()
}

export const checkoutGiftCard = async (partnerId, data) => {

    var requestOptions = null
    const headers = await buildHeaders()
    if (headers) {
        requestOptions = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(data)
        }
    } else {
        throw Error("Not authenticated??")
    }

    const response = await fetch(`${BASE_URL}/app/checkout?giftPartnerId=${partnerId}`, requestOptions)

    return response.json()
}

export const checkoutClass = async (classId, data) => {

    let requestOptions = null
    const headers = await buildHeaders()
    if (headers) {
        requestOptions = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(data)
        }
    } else {
        throw Error("Not authenticated??")
    }

    const response = await fetch(`${BASE_URL}/app/checkout?classId=${classId}`, requestOptions)

    return response.json()
}

export const checkoutOffering = async (offeringId, data) => {

    let requestOptions = null
    const headers = await buildHeaders()
    if (headers) {
        requestOptions = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(data)
        }
    } else {
        throw Error("Not authenticated??")
    }

    const response = await fetch(`${BASE_URL}/app/checkout?offeringId=${offeringId}`, requestOptions)

    return response.json()
}

export const buildHeaders = async () => {
    const user = firebase.auth().currentUser
    if (!user) {
        return null
    }
    const authToken = await user.getIdToken()

    return new Headers({
        'Authorization': `Bearer ${authToken}`,
        'Content-Type': 'application/json'
    })
}